import ReactDOM from "react-dom";
import { ThemeProvider } from "@material-ui/core/styles";
import theme from "@/theme/muiTheme";
import { LanguageProvider } from "@/langs/LanguageProvider";
import GlobalProvider from "@/GlobalProvider";

const ReactUnmount = ReactDOM.unmountComponentAtNode
export const ReactRender = (component, dom) => {
  return ReactDOM.render(
    <ThemeProvider theme={theme}>
      <GlobalProvider>
      <LanguageProvider noLangConf>{component}</LanguageProvider>
      </GlobalProvider>
    </ThemeProvider>,
    dom
  );
};

export {
  ReactUnmount
}